/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_ADD_CUSTOMER_ORDER_SUCCESS = 'REQUEST_ADD_CUSTOMER_ORDER_SUCCESS';